// class ShopTheLookElement extends HTMLElement {
//   connectedCallback() {
//     setTimeout(() => this.init(), 100);
//   }

//   init() {
//     this.hotspots = Array.from(this.querySelectorAll(".hotspot"));
//     this.productCarouselEl =
//       this.querySelector(".look-product-carousel") ||
//       this.querySelector("#shop-the-look-carousel");

//     if (!this.productCarouselEl || !this.hotspots.length) return;

//     this.bindEvents();
//     this.waitForFlickityAndSync();
//     this.setActiveByIndex(0);
//   }
//   bindEvents() {
//     this.hotspots.forEach((hotspot) => {
//       hotspot.addEventListener("click", (e) => {
//         const hotspotIndex = Number(hotspot.dataset.productIndex);
//         const hotspotBlockId = hotspot.dataset.blockId;

//         if (window.innerWidth >= 750) {
//           e.preventDefault();
//           e.stopPropagation();

//           const slides = this.productCarouselEl.querySelectorAll(
//             ".product-shop-the-look-slide"
//           );
//           let matchedIndex = null;

//           slides.forEach((slide, i) => {
//             // ✅ Fix Shopify dataset transformations
//             const slideIndex = Number(
//               slide.dataset.forIndex ??
//                 slide.dataset.forindex ??
//                 slide.getAttribute("data-for-index")
//             );

//             const slideBlockId =
//               slide.dataset.blockId ?? slide.getAttribute("data-block-id");

//             // ✅ MATCH RULE: BOTH must match
//             if (
//               slideIndex === hotspotIndex &&
//               slideBlockId === hotspotBlockId
//             ) {
//               matchedIndex = i;
//             }
//           });

//           if (matchedIndex !== null) {
//             this.navigateTo(matchedIndex);
//           } else {
//             console.warn(
//               "❌ No matching slide found for hotspot:",
//               hotspotIndex,
//               hotspotBlockId
//             );
//           }
//         }
//       });
//     });
//   }

//   navigateTo(index) {
//     const trySelect = () => {
//       const flickity = this.productCarouselEl.flickity;
//       if (flickity?.select) {
//         flickity.select(index);
//         return true;
//       }

//       if (this.productCarouselEl.dataset.initiated) {
//         const dots = this.productCarouselEl.querySelectorAll(
//           ".flickity-page-dots li, .flickity-page-dots .dot"
//         );
//         if (dots && dots[index]) {
//           dots[index].click();
//           return true;
//         }
//       }

//       return false;
//     };

//     const start = Date.now();
//     const poll = () => {
//       if (trySelect()) return;
//       if (Date.now() - start > 3000) return;
//       setTimeout(poll, 60);
//     };
//     poll();
//   }

//   setActiveByIndex(index) {
//     this.hotspots.forEach((h) => h.classList.remove("hotspot-active"));
//     const active = this.hotspots[index];
//     if (active) active.classList.add("hotspot-active");
//   }

//   waitForFlickityAndSync() {
//     const flickityReady = () => {
//       const flickity = this.productCarouselEl.flickity;
//       if (flickity && typeof flickity.on === "function") {
//         flickity.on("change", (index) => {
//           this.setActiveByIndex(index);
//         });

//         this.productCarouselEl.addEventListener("transitionend", () => {
//           const flick = this.productCarouselEl.flickity;
//           const idx =
//             flick && typeof flick.selectedIndex === "number"
//               ? flick.selectedIndex
//               : null;
//           if (idx !== null) this.setActiveByIndex(idx);
//         });

//         return true;
//       }

//       if (this.productCarouselEl.dataset.initiated) {
//         const dots = this.productCarouselEl.querySelectorAll(
//           ".flickity-page-dots li, .flickity-page-dots .dot"
//         );
//         if (dots && dots.length === this.hotspots.length) {
//           dots.forEach((dot, i) => {
//             dot.addEventListener("click", () => this.setActiveByIndex(i));
//           });
//         }
//         return true;
//       }

//       return false;
//     };

//     const start = Date.now();
//     const poll = () => {
//       if (flickityReady()) return;
//       if (Date.now() - start > 3000) return;
//       setTimeout(poll, 80);
//     };
//     poll();
//   }
// }

// customElements.define("marmeto-shop-the-look", ShopTheLookElement);


class ShopTheLookElement extends HTMLElement {
  connectedCallback() {
    this.init();
  }

  init() {
    this.hotspots = Array.from(this.querySelectorAll(".hotspot"));
    this.carousel =
      this.querySelector(".look-product-carousel") ||
      this.querySelector("#shop-the-look-carousel");

    if (!this.hotspots.length || !this.carousel) return;

    this.productSlides = Array.from(
      this.carousel.querySelectorAll(".product-shop-the-look-slide")
    );

    this.bindEvents();
  }

  bindEvents() {
    this.hotspots.forEach((hotspot) => {
      hotspot.addEventListener("click", (e) => {
        if (window.innerWidth < 750) return;

        e.preventDefault();
        e.stopPropagation();

        const hotspotIndex = Number(hotspot.dataset.productIndex);
        const hotspotBlockId = hotspot.dataset.blockId;

        const flickityIndex = this.productSlides.findIndex((slide) => {
          const slideIndex = Number(
            slide.getAttribute("data-for-index")
          );
          const slideBlockId = slide.getAttribute("data-block-id");

          return (
            slideIndex === hotspotIndex &&
            slideBlockId === hotspotBlockId
          );
        });

        if (flickityIndex === -1) return;

        this.selectSlide(flickityIndex);
      });
    });
  }

  selectSlide(index) {
    const trySelect = () => {
      const flickityInstance = Flickity.data(this.carousel);

      if (flickityInstance) {
        flickityInstance.select(index);
        return true;
      }
      return false;
    };

    const start = Date.now();
    const poll = () => {
      if (trySelect()) return;
      if (Date.now() - start > 4000) return;
      setTimeout(poll, 80);
    };
    poll();
  }
}

customElements.define("marmeto-shop-the-look", ShopTheLookElement);
